import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../lib/AuthContext'
import { actualizarMiPerfil } from '../../lib/portalClienteApi'
import { supabase } from '../../lib/supabase'

export default function ClientePerfil() {
  const { user, profile } = useAuth()
  const navigate = useNavigate()
  const [f, setF] = useState({ nombre: '', phone: '' })
  const [saving, setSaving] = useState(false)
  const [savedAt, setSavedAt] = useState(null)
  const [err, setErr] = useState(null)

  useEffect(() => {
    if (profile) setF({ nombre: profile.nombre || '', phone: profile.phone || '' })
  }, [profile])

  async function guardar() {
    setSaving(true); setErr(null)
    try {
      await actualizarMiPerfil(f)
      setSavedAt(new Date())
    } catch (e) { setErr(e.message) }
    finally { setSaving(false) }
  }

  async function logout() {
    await supabase.auth.signOut()
    navigate('/login', { replace: true })
  }

  async function cambiarPassword() {
    const { error } = await supabase.auth.resetPasswordForEmail(user.email, {
      redirectTo: `${window.location.origin}/set-password`,
    })
    if (error) alert('Error: ' + error.message)
    else alert('Te mandamos un email con el link para cambiar tu contraseña.')
  }

  return (
    <div className="pf-app">
      {/* Navbar */}
      <nav className="pf-nav">
        <div className="pf-nav-inner">
          <Link to="/cliente" className="pf-logo">
            <img src="/isotipo.png" alt="" className="pf-logo-iso" />
            <span>Lim<em>pack</em></span>
          </Link>
          <div className="pf-nav-actions">
            <Link to="/cliente" className="pf-nav-link">← Mi cuenta</Link>
            <button onClick={logout} className="pf-nav-logout">Salir</button>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="pf-hero">
        <div className="pf-hero-inner">
          <div className="pf-hero-pill"><span className="pf-hero-dot"></span> Mi perfil</div>
          <h1 className="pf-hero-h1">👤 Tus datos</h1>
          <p className="pf-hero-sub">Actualizá tu nombre, teléfono y contraseña.</p>
        </div>
      </section>

      <main className="pf-main">
        {/* Card datos personales */}
        <div className="pf-card">
          <h3 className="pf-card-h3">Datos personales</h3>
          <Field label="Nombre completo">
            <input type="text" value={f.nombre} onChange={e => setF({ ...f, nombre: e.target.value })} placeholder="Juan Pérez" />
          </Field>
          <Field label="Teléfono">
            <input type="tel" value={f.phone} onChange={e => setF({ ...f, phone: e.target.value })} placeholder="098 123 456" />
          </Field>
          <Field label="Email">
            <input type="email" value={user?.email || ''} disabled />
            <div className="pf-hint">Para cambiar tu email contactanos por WhatsApp.</div>
          </Field>
          {err && <div className="pf-err">{err}</div>}
          {savedAt && <div className="pf-ok">✓ Guardado</div>}
          <div className="pf-actions">
            <button className="pf-btn-primary" onClick={guardar} disabled={saving}>
              {saving ? 'Guardando…' : '💾 Guardar cambios'}
            </button>
          </div>
        </div>

        {/* Card seguridad */}
        <div className="pf-card">
          <h3 className="pf-card-h3">🔐 Seguridad</h3>
          <p className="pf-card-sub">Cambiá tu contraseña con un email de reset.</p>
          <button className="pf-btn-secondary" onClick={cambiarPassword}>
            Cambiar contraseña
          </button>
        </div>
      </main>

      <style>{styles}</style>
    </div>
  )
}

function Field({ label, children }) {
  return (
    <label className="pf-field">
      <b>{label}</b>
      {children}
    </label>
  )
}

const styles = `
:root {
  --pf-navy: #1a3461;
  --pf-teal: #00c4d4;
  --pf-cream: #F8FAFC;
  --pf-line: #e2e8f0;
  --pf-muted: #64748b;
}
html, body { background: var(--pf-cream); margin: 0 }
.pf-app {
  min-height: 100vh;
  background: var(--pf-cream);
  font-family: 'Inter', system-ui, sans-serif;
  color: var(--pf-navy);
  -webkit-font-smoothing: antialiased;
  display: flex; flex-direction: column;
}

/* Navbar */
.pf-nav { background: var(--pf-navy); }
.pf-nav-inner {
  max-width: 1100px; margin: 0 auto; padding: 14px 20px;
  display: flex; justify-content: space-between; align-items: center;
}
.pf-logo {
  display: flex; align-items: center; gap: 10px;
  color: #fff; text-decoration: none; font-weight: 800; font-size: 22px;
}
.pf-logo em { color: var(--pf-teal); font-style: normal; }
.pf-logo-iso { width: 28px; height: 28px; border-radius: 6px; background: #fff; padding: 4px; }
.pf-nav-actions { display: flex; align-items: center; gap: 12px }
.pf-nav-link {
  color: rgba(255,255,255,.85); text-decoration: none; font-weight: 600; font-size: 14px;
  padding: 6px 12px;
}
.pf-nav-link:hover { color: #fff }
.pf-nav-logout {
  background: rgba(255,255,255,.1); border: 1px solid rgba(255,255,255,.2);
  color: #fff; font-family: inherit; font-size: 13px; font-weight: 600;
  padding: 7px 16px; border-radius: 999px; cursor: pointer;
}
.pf-nav-logout:hover { background: rgba(255,255,255,.2); }

/* Hero */
.pf-hero {
  background: linear-gradient(135deg, var(--pf-navy) 0%, #1a5cb8 100%);
  padding: 32px 20px;
}
.pf-hero-inner { max-width: 1100px; margin: 0 auto; text-align: center; }
.pf-hero-pill {
  display: inline-flex; align-items: center; gap: 6px;
  background: rgba(255,255,255,.12);
  color: var(--pf-teal); border-radius: 999px;
  padding: 5px 12px; font-size: 11px; font-weight: 800;
  letter-spacing: .08em; text-transform: uppercase; margin-bottom: 14px;
}
.pf-hero-dot {
  width: 8px; height: 8px; border-radius: 999px; background: var(--pf-teal);
}
.pf-hero-h1 { color: #fff; margin: 0 0 6px; font-size: 32px; font-weight: 800; }
.pf-hero-sub { color: rgba(255,255,255,.85); margin: 0; font-size: 14px; }

/* Main */
.pf-main {
  max-width: 720px; width: 100%; margin: 0 auto;
  padding: 28px 20px 60px; flex: 1; box-sizing: border-box;
}

/* Cards */
.pf-card {
  background: #fff; border-radius: 16px;
  border: 1px solid var(--pf-line);
  box-shadow: 0 4px 16px rgba(26,52,97,.04);
  padding: 24px; margin-bottom: 16px;
}
.pf-card-h3 { color: var(--pf-navy); margin: 0 0 14px; font-size: 18px; font-weight: 700 }
.pf-card-sub { color: var(--pf-muted); font-size: 13px; margin: 0 0 14px; line-height: 1.5 }

/* Fields */
.pf-field { display: block; margin-bottom: 14px; }
.pf-field b {
  display: block; font-size: 11px; font-weight: 700; color: var(--pf-muted);
  letter-spacing: .08em; text-transform: uppercase; margin-bottom: 6px;
}
.pf-field input, .pf-field select {
  width: 100%; padding: 11px 13px; border-radius: 10px;
  border: 1px solid var(--pf-line); font-size: 15px; font-family: inherit;
  color: var(--pf-navy); box-sizing: border-box; background: #fff;
  transition: border-color .15s, box-shadow .15s;
}
.pf-field input:focus, .pf-field select:focus {
  outline: none; border-color: var(--pf-teal);
  box-shadow: 0 0 0 3px rgba(0,196,212,.15);
}
.pf-field input:disabled { background: #f3f4f6; color: var(--pf-muted); cursor: not-allowed; }
.pf-hint { font-size: 11px; color: var(--pf-muted); margin-top: 4px }

/* Botones */
.pf-actions { display: flex; justify-content: flex-end; margin-top: 4px }
.pf-btn-primary {
  padding: 11px 20px; border: 0;
  background: var(--pf-navy); color: #fff;
  border-radius: 10px; font-weight: 700; font-size: 14px;
  cursor: pointer; font-family: inherit;
}
.pf-btn-primary:hover:not(:disabled) { background: #0f2147; }
.pf-btn-primary:disabled { opacity: .6; cursor: not-allowed; }
.pf-btn-secondary {
  padding: 11px 20px; border: 1px solid var(--pf-line);
  background: #fff; color: var(--pf-navy);
  border-radius: 10px; font-weight: 600; font-size: 14px;
  cursor: pointer; font-family: inherit;
}
.pf-btn-secondary:hover { background: #f9fafb }

.pf-err {
  padding: 10px 12px; background: #fee2e2; border: 1px solid #fca5a5;
  border-radius: 8px; color: #991b1b; font-size: 13px; margin-bottom: 12px;
}
.pf-ok {
  padding: 10px 12px; background: #ecfdf5; border: 1px solid #86efac;
  border-radius: 8px; color: #065f46; font-size: 13px; margin-bottom: 12px;
}
`
